import React from "react";
import TabLabel from "./TabLabel";
import ProeveResultater from "./ProeveResultater";
import UtenlandskeResultater from "./UtenlandskeResultater";
import ElementHelp from './ElementHelp';
import {useHistory, withRouter} from "react-router-dom";
import qs from "query-string";

const Proever = (props) => {
    const {hund, jaktresultater, bruksresultater,
        aktivitetsresultater, utenlandskeResultater} = props;

    let history = useHistory();
    const parsed = qs.parse(decodeURI(props.location.search));
    let tabId = 'jakt';
    if (parsed.proeveTab !== undefined) {
        tabId = parsed.proeveTab;
    }

    const show = (t) => {
        if (tabId === t) {
            return true;
        }
        return false;
    };

    const setTabId = (t) => {
        let params = parsed
        if (t !== tabId) {
            params.proeveTab = t;
        }
        delete params.stamLabel;
        delete params.query;
        delete params.antall;
        const currentPath = props.location.pathname;
        history.push(currentPath + "?" + qs.stringify(params));
    };

    const renderTabTitelClass = (t) => {
        if (tabId === t) {
            return "tabs-title tab-active";
        }
        return "tabs-title";
    };

    return (
        <div className="dogweb-box">
            <div className="dogweb-card-header">
                <div className="card-title">PRØVER </div>
                <div className="name-active-dog"> {hund.navn}</div>
                <ElementHelp slug={'prover'}/>
            </div>
            <div className="tab-container">
                <ul className="tabs" id="resultater">
                    <li className={renderTabTitelClass('jakt')}>
                        <button onClick={() => setTabId("jakt")} >
                            <TabLabel name="JAGT" count={jaktresultater.length} />
                        </button>
                    </li>
                    <li className={renderTabTitelClass('bruks')}>
                        <button onClick={() => setTabId("bruks")} >
                            <TabLabel name="BRUGSPRØVE" count={bruksresultater.length} />
                        </button>
                    </li>
                    <li className={renderTabTitelClass('aktivitet')}>
                        <button onClick={() => setTabId("aktivitet")} >
                            <TabLabel name="AKTIVITET" count={aktivitetsresultater.length} />
                        </button>
                    </li>
                    <li className={renderTabTitelClass('utenlandsk')}>
                        <button onClick={() => setTabId("utenlandsk")} >
                            <TabLabel name="ANDRE" count={utenlandskeResultater.length} />
                        </button>
                    </li>
                </ul>

                <div className="tabs-panel is-active" >
                    {
                        show('jakt') &&
                            <ProeveResultater resultater={jaktresultater} />

                    }
                    {
                        show('bruks') &&
                            <ProeveResultater resultater={bruksresultater} />

                    }

                    {
                        show('aktivitet') &&
                            <ProeveResultater resultater={aktivitetsresultater} />

                    }

                    {
                        show('utenlandsk') &&
                            <UtenlandskeResultater resultater={utenlandskeResultater} className="dogweb-prover" />
                    }

                    <div className="dogweb-card-footer">
                    </div>
                </div>
            </div>
        </div>
    );
};

export default withRouter (Proever);
